import { IHeaderType } from "../../../types/types";
import SectionHeader from "../../../utils/section-header";

type Props = {
};

const RowOne = (props: Props) => {

  return (
    <>
      <SectionHeader
        titleText={"Discover what we offer"}
        descText={"Uncover solutions tailored for growth. Strategies crafted for impact. Services designed for transformation. Explore what we offer businesses like yours."}
        type={IHeaderType.h2}
      />
    </>
  );
};

export default RowOne;
